<template>
    <div>
        <div style="display: flex;justify-content: space-between;">
            <div style="background-color: rgb(2, 2, 2,40%);padding: 0 6px;width: 30%;min-width: 30px;">
                <div style="padding: 6px;text-align: center;font-size: 20px;color: #fff;">{{ swiper.name1 }}</div>
                <el-carousel>
                    <el-carousel-item v-for="(item,index) in swiper.img1" :key="index">
                        <el-image style="width: 100%;" :src="item" fit="contain"></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div style="background-color: rgb(2, 2, 2,40%);padding: 0 6px;width: 30%;">
                <div style="padding: 6px;text-align: center;font-size: 20px;color: #fff;">{{ swiper.name2 }}</div>
                <el-carousel>
                    <el-carousel-item v-for="(item,index) in swiper.img2" :key="index">
                        <el-image style="width: 100%;" :src="item" fit="contain"></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div style="background-color: rgb(2, 2, 2,40%);padding: 0 6px;width: 30%;">
                <div style="padding: 6px;text-align: center;font-size: 20px;color: #fff;">{{ swiper.name3 }}</div>
                <el-carousel>
                    <el-carousel-item v-for="(item,index) in swiper.img3" :key="index">
                        <el-image style="width: 100%;" :src="item" fit="contain"></el-image>
                    </el-carousel-item>
                </el-carousel>
               
            </div>
        </div>
        <div style="display: flex;align-items: center;margin-top: 10px;">
            <div>
                <el-image style="width: 40px;height: 40px;" src="https://kaifaceshi.08170817.com/static/admin/notice.png" fit="fill"></el-image>
            </div>
            <div class="announcement-bar">
                <div class="announcement-content">
                    芯云科技，矢志助推全国手机门店销售业绩攀新高！作为科技与智慧的融合体，我们始终站在行业前沿，致力于通过先进的技术和贴心的服务！
                </div>
            </div>
        </div>
        <!-- 商品组 -->
        <div class="content">
            <div style="display: flex;justify-content: space-between;background-color: rgb(2, 2, 2,40%);border-radius: 10px 10px 0 0;padding: 10px 20px;">
                <div style="display: flex;">
                    <div class="tab tabactive" @click="$router.replace('/brandnew/brandnewModel');">前段展示</div>
                    <div class="tab" @click="$router.replace('/brandnew/brandnewSort');">分类管理</div>
                    <div class="tab" @click="$router.replace('/model/memory');">内存管理</div>
                    <div class="tab" @click="$router.replace('/model/colorList');">颜色管理</div>
                </div>
                <div style="display: flex;">
                    <div class="tabOperate" style="background-color: #409eff;" @click="dialogAddVisible = true">添加机型</div>
                    <div class="tabOperate" style="background-color: #e6a23c;" @click="dialogExportVisible = true">导入机型</div>
                </div>
            </div>
            <div style="background-color: #fff;">
                <div style="display: flex;">
                    <!-- <div class="table-title text-stroke" style="width: 5%;">ID</div> -->
                    <!-- <div class="table-title text-stroke" style="width: 10%;">来源</div> -->
                    <div class="table-title text-stroke" style="width: 10%;">分类</div>
                    <div class="table-title text-stroke" style="width: 23%;">机型</div>
                    <div class="table-title text-stroke" style="width: 15%;">内存</div>
                    <div class="table-title text-stroke" style="width: 15%;">颜色</div>
                    <div class="table-title text-stroke" style="width: 22%;">价格</div>
                    <!-- <div class="table-title text-stroke" style="width: 11%;">旧价格</div> -->
                    <!-- <div class="table-title text-stroke" style="width: 8%;">官网价格</div> -->
                     <!--<div class="table-title text-stroke" style="width: 6%;">权重</div>-->
                    <!-- <div class="table-title text-stroke" style="width: 10%;">添加时间</div> -->
                    <!--<div class="table-title text-stroke" style="width: 5%;">状态</div>-->
                   <div class="table-title text-stroke" style="width: 15%;">操作</div>
                </div>
                <div id="scrollable-area" style="max-height: 60vh;">
                    <div style="display: flex;" v-for="(item,index) in  tableData" :key="index">
                        <!-- <div class="table-item" style="width: 5%;">{{ item.id }}</div> -->
                        <!-- <div class="table-item" style="width: 10%;">{{ item.id }}</div> -->
                        <div class="table-item" style="width: 10%;">{{ item.sortname }}</div>
                        <div class="table-item" style="width: 23%;">{{ item.model }}</div>
                        <div class="table-item" style="width: 15%;">{{ item.memory }}</div>
                        <div class="table-item" style="width: 15%;">{{ item.color }}</div>
                        <div class="table-item" style="width: 22%;">{{ item.price }}</div>
                        <!-- <div class="table-item" style="width: 11%;">{{ item.price_old }}</div> -->
                        <!-- <div class="table-item" style="width: 8%;">{{ item.official_price }}</div> -->
                        <!--<div class="table-item" style="width: 6%;">{{item.weight }}</div>-->
                        <!-- <div class="table-item" style="width: 10%;">{{ item.create_time | strtime }}</div> -->
                        <!--<div class="table-item" style="width: 5%;">
                            <el-tag type="success" size="medium" v-if="item.status == 1">显示</el-tag>
                            <el-tag type="danger" size="medium" v-else>未显示</el-tag>
                        </div>-->
                        <div class="table-item" style="width: 15%;">
                            <el-button size="mini" type="primary" icon="el-icon-s-tools"
                                        @click="handleEdit(index, item)">编辑</el-button>
                            <el-button size="mini" type="danger" icon="el-icon-error"
                                        @click="handleDelete(index, item)">删除</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 分页组件 -->
            <div class="Pagination">
                <Pagination :total="total" :pageSize="pageSize" @currentChange="currentChange"></Pagination>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import draggable from 'vuedraggable';
import Pagination from '@/components/pagination/Pagination.vue';
export default {
    components: {
        draggable,
        Pagination
    },
    data(){
        return{
            top_data:{},
            data:{},
            swiper:{},
            list1:[{name:'张一',weight:1},{name:'张二',weight:2},{name:'张三',weight:3},{name:'张四',weight:4},{name:'张五',weight:5},{name:'张六',weight:6}],
            mubiao1:{},
            mubiao2:{},
            type:true,
            tableData: [],
            total: 10,
            pageSize: 10,
            formInline: {
                model: '',
                memory: '',
                status: '',
                page: 1,
            },
        }
    },
    created(){
        // this.getdata()
        // this.getmodelList()
        // this.getMaterial()
        this.$router.replace('/brandnew/brandnewModel')

    },
    mounted(){
        
       
    },
    methods:{
        onEnd() {
            console.log('Drag ended', this.list1);
        },
        async getdata(){
            let res = await this.$api.getzongSetting()
            this.data = res.data.data

            let ress = await this.$api.hswiper()
            this.swiper = ress.data.data
            console.log('this.swiper',this.swiper)
        },
        async getmodelList() {
            let res = await this.$api.modelBrandnewList(this.formInline)
            this.tableData = res.data.data.modelList
            this.total = res.data.data.total
            this.pageSize = res.data.data.pageSize
        },
        async getMaterial() {
            let res = await this.$api.material()
            this.memoryList = res.data.data.memory
            this.colorList = res.data.data.color

            let resSort = await this.$api.allsortBrandnewList()
            this.sortList = resSort.data.data.sortList
            // this.sortListzi = resSort.data.data.sortListzi
            // this.sortListzong = resSort.data.data.sortListzong
        },
        currentChange(val) {
            console.log('分页功能', val)
            this.formInline.page = val
            this.getmodelList()
        },
        async linechart(){
            let res = await this.$api.linechart()
            var chartDom = document.getElementById('charts1');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                xAxis: {
                    type: 'category',
                    data: res.data.data.daysAgo
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: res.data.data.datanum,
                        type: 'line',
                        smooth: true
                    }
                ]
            };

            option && myChart.setOption(option);

        },
        async pie(){
            let res = await this.$api.pie()
            var chartDom = document.getElementById('charts2');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                title: {
                    text: '稿件状态',
                    subtext: '各个状态稿件分布比例',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left'
                },
                series: [
                    {
                        name: '稿件数量数量',
                        type: 'pie',
                        radius: '50%',
                        data: res.data.data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };

            option && myChart.setOption(option);

        },
        async indexinfo(){
            let res = await this.$api.homeinfo()
            this.top_data = res.data.data
            console.log('首页res',res)
        },
        to(e){
            this.$router.push(e)
        }
    }
}
</script>

<style lang="less" scoped>
.header {
    display: flex;
    padding-right: 30px;
    margin-bottom: 50px;

    .item {
        flex: 1;
        height: 100px;
        padding: 10px;
        background: #fff;
        border-radius: 10px;
        margin-left: 20px;
        margin-right: 20px;
        font-weight: bold;
        color: #fff;
        // text-align: center;
        position: relative;

        .num {
            font-size: 22px;
            margin: 10px;
            color: #fff;
        }

        .bottom {
            position: absolute;
            border-top: 1px solid rgb(246, 245, 245);
            padding: 10px 20px;
            bottom: 0;
            right: 0;
            left: 0;
            color: #fff;
            font-weight: normal;
        }
    }

    .item:nth-child(1) {
        background-image: linear-gradient(#df887d, #88554d);
    }

    .item:nth-child(2) {
        background-image: linear-gradient(#409eff, #2e556e);
    }

    .item:nth-child(3) {
        background-image: linear-gradient(#b54fa8, #713c7a);
    }

    .item:nth-child(4) {
        background-image: linear-gradient(#1cd2f1, #39717a);
    }
}
.infotxt {
    font-size: 20px;
    margin: 15px;
    text-align: center;
}
.infodata {
    margin: 15px;
    font-size: 15px;
    text-align: center;
    
}

// 图表

// .content {
//     margin: 20px;
//     display: flex;
//     height: 320px;

//     .time-info {
//         flex: 2;
//         background: #fff;
//         margin-right: 20px;
//         padding: 10px;
//     }

//     .area {
//         flex: 1;
//         background: #fff;
//         padding: 10px;
//     }
// }

//内容

.home-footer {
    display: flex;
    padding-left: 20px;
    margin-bottom: 20px;

    .box-card {
        flex: 1;
        margin-right: 30px;

        span {
            font-weight: 600;
        }
    }
}
.announcement-bar {
  overflow: hidden; /* 隐藏溢出的内容 */
  white-space: nowrap; /* 防止文本换行 */
  color: #fff; /* 文字颜色 */
  font-weight: 600;
  font-size: 20px;
  padding: 10px; /* 内边距 */
}
.announcement-content {
  display: inline-block; /* 使内容可滚动 */
  animation: marquee 20s linear infinite; /* 应用动画 */
}
@keyframes marquee {
  from { transform: translateX(100%); } /* 开始时，内容在右边 */
  to { transform: translateX(-100%); } /* 结束时，内容在左边 */
}
.tab{
    background-color: #fff;
    padding: 8px 6px;
    min-width: 40px;
    font-size: 20px;
    font-weight: 600;
    border-radius: 10px;
}
.table-title{
    text-align: center;
    width:20%;
    color: #fff;
    border: 1px solid #000;
    padding: 10px 0;
    font-size: 40px;
    font-weight: 600;
}
.text-stroke {
  text-shadow: 
    -2px -2px 1px #000,  
    2px -2px 1px #000,
    -2px  2px 1px #000,
    2px  2px 1px #000;
}
.table-item{
    text-align: center;
    width:20%;
    border: 1px solid #000;
    padding: 10px 0;
    font-size: 30px;
    font-weight: 600;
}
.list {
  list-style: none;
  .list-item {
    // 设置 动画效果
    transition: transform .3s;
    cursor: move;
    width: 300px;
    background: #EA6E59;
    border-radius: 4px;
    color: #FFF;
    margin-bottom: 6px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
}
.header {
    background: #ffffff00;
    margin-bottom: 20px;
    padding: 10px;

    .el-form-item {
        margin-bottom: 16px;
    }

    .group {
        border: 1px solid #eee;
        padding: 8px;
    }
}

.content {
    background: #ffffff00;

    /deep/.active-header {
        color: #333333;
    }

    /deep/.table-center {
        text-align: center;
        color: #000;
    }

    .Pagination {
        padding: 10px;
        background: #fff;
    }
    /deep/.el-tag--medium{
        font-size: 20px;
        height: 50px;
        line-height: 50px;
    }

    .scroll-container {
        overflow-y: scroll;
        height: 38vh;
        /* 根据需要设置高度 */
    }
}
.fontcolor /deep/.el-form-item__label{color: #fff !important;}
#scrollable-area {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 10%; /* 根据需要设置 */
}
</style>